module.exports = __webpack_public_path__ + "static/media/stage.aedfe271.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/images/whereby/stage.mp4
// module id = 334
// module chunks = 0